import loadable from "@loadable/component";

export const ResidentialList = loadable(() => import("./list"));
